import { render, staticRenderFns } from "./twoCourse.vue?vue&type=template&id=32fcd0e8&scoped=true"
import script from "./twoCourse.vue?vue&type=script&lang=js"
export * from "./twoCourse.vue?vue&type=script&lang=js"
import style0 from "./twoCourse.vue?vue&type=style&index=0&id=32fcd0e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fcd0e8",
  null
  
)

export default component.exports